import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { unsubscribeUserAction } from 'root-redux/actions/user'
import {
  selectCustomerAvailableFeatures,
  selectUserCountry,
} from 'root-redux/selects/user'
import { TAppDispatch } from 'root-redux/store/store'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'
import { US_COUNTRY_CODE } from 'root-constants'

import { useRetentionFlowV2Config } from './useRetentionFlowV2Config'

export const useCancelSubscription = () => {
  const { search } = useLocation()
  const dispatch: TAppDispatch = useDispatch()
  const country = useSelector(selectUserCountry)
  const { pauseAvailable } = useSelector(selectCustomerAvailableFeatures)
  const { hasCancelConfirmation } = useRetentionFlowV2Config()
  const isCancelingRef = useRef(false)
  const [isFeedbackPopupShown, setIsFeedbackPopupShown] = useState(false)

  const isUsUser = country.toUpperCase() === US_COUNTRY_CODE
  const isCancelConfirmationShown = hasCancelConfirmation && !isUsUser

  const cancelSubscription = () => {
    if (isCancelingRef.current) return

    isCancelingRef.current = true
    dispatch(unsubscribeUserAction())
    goTo({ pathname: PageId.CANCELED_SUBSCRIPTION, search })
  }

  const askFeedback = () => setIsFeedbackPopupShown(true)

  const closeFeedbackPopup = () => setIsFeedbackPopupShown(false)

  const goToCancellation = () => {
    if (!isCancelConfirmationShown) {
      askFeedback()
      return
    }

    goTo({ pathname: PageId.CANCEL_CONFIRMATION, search })
  }

  const goToPauseOffer = () => {
    if (!pauseAvailable) {
      goToCancellation()
      return
    }

    goTo({ pathname: PageId.PAUSE_SUBSCRIPTION, search })
  }

  return {
    isCancelConfirmationShown,
    isFeedbackPopupShown,
    askFeedback,
    closeFeedbackPopup,
    cancelSubscription,
    goToCancellation,
    goToPauseOffer,
  }
}
